/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19.7977 15.0002C19.8662 14.9078 19.9337 14.8145 20.0001 14.7204C21.1765 13.052 22.0001 11.1176 22.0001 9.00014C22.0001 5.50016 19.0001 3.04357 16.0001 3.00016C14.5001 2.97845 13.0001 3.50018 12.0001 5.00017C11.0001 3.50018 9.47411 3.00016 8.00006 3.00016C7.83322 3.00016 7.66638 3.00789 7.50006 3.0231"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L4.3116 4.3116M21 21L17.5064 17.5064M17.5064 17.5064C15.093 19.7034 12.5092 21 12 21C11 21 2 16 2 8.99999C2 7.03227 2.94824 5.38062 4.3116 4.3116M17.5064 17.5064L4.3116 4.3116"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 9.00001C2 16 11 21 12 21C12.5092 21 15.093 19.7034 17.5064 17.5064L4.3116 4.31161C2.94824 5.38063 2 7.03228 2 9.00001Z"
				fill="currentColor"
			/>
			<path
				d="M2 2L4.3116 4.3116M21 21L17.5064 17.5064M17.5064 17.5064C15.093 19.7034 12.5092 21 12 21C11 21 2 16 2 8.99999C2 7.03227 2.94824 5.38062 4.3116 4.3116M17.5064 17.5064L4.3116 4.3116M19.7977 15C19.8662 14.9076 19.9337 14.8144 20 14.7203C21.1765 13.0519 22 11.1174 22 8.99999C22 5.50001 19 3.04341 16 3.00001C14.5 2.9783 13 3.50003 12 5.00002C11 3.50003 9.47405 3.00001 8 3.00001C7.83316 3.00001 7.66632 3.00774 7.5 3.02294"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L3.21886 4.27952C2.03635 5.46156 1.25 7.09851 1.25 8.99999C1.25 12.8218 3.69522 16.01 6.12491 18.1839C7.35322 19.2829 8.61307 20.1554 9.63581 20.7561C10.1469 21.0562 10.6068 21.2932 10.9812 21.4579C11.1677 21.54 11.3419 21.6081 11.4962 21.657C11.6316 21.7 11.8167 21.75 12 21.75C12.186 21.75 12.3746 21.6984 12.5126 21.6542C12.6701 21.6038 12.8484 21.5336 13.0398 21.4487C13.424 21.2783 13.8965 21.0331 14.4213 20.7224C15.321 20.1897 16.3981 19.4503 17.4737 18.5343L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L2.53033 1.46967Z"
				fill="currentColor"
			/>
			<path
				d="M12.624 5.41605C13.4503 4.17673 14.6789 3.73097 15.9891 3.74993C18.6341 3.7882 21.25 5.96278 21.25 8.99999C21.25 10.9177 20.5044 12.7036 19.3871 14.2881C19.3242 14.3772 19.2603 14.4656 19.1952 14.5533C18.9485 14.886 19.0182 15.3557 19.3509 15.6024C19.6836 15.8492 20.1534 15.7795 20.4001 15.4467C20.4721 15.3497 20.5431 15.2516 20.6129 15.1525C21.8486 13.4002 22.75 11.3172 22.75 8.99999C22.75 5.03724 19.3659 2.29863 16.0109 2.25008C14.5981 2.22964 13.1283 2.64408 11.9984 3.80946C10.86 2.64616 9.37536 2.25001 8 2.25001C7.80999 2.25001 7.62037 2.25881 7.43172 2.27606C7.01922 2.31377 6.7154 2.67874 6.75311 3.09123C6.79083 3.50372 7.15579 3.80754 7.56828 3.76983C7.71228 3.75667 7.85633 3.75001 8 3.75001C9.30338 3.75001 10.5543 4.18355 11.376 5.41605C11.5151 5.6247 11.7492 5.75002 12 5.75002C12.2508 5.75002 12.4849 5.62469 12.624 5.41605Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 2L4.3116 4.3116M21 21L17.5064 17.5064M17.5064 17.5064C15.093 19.7034 12.5092 21 12 21C11.6201 21 10.0859 20.2785 8.32914 19M17.5064 17.5064L4.3116 4.3116M4.3116 4.3116C2.94824 5.38062 2 7.03227 2 8.99999C2 11.6781 3.31732 14.0634 5 15.988M19.7977 15C19.8662 14.9076 19.9337 14.8144 20 14.7203C21.1765 13.0519 22 11.1174 22 8.99999C22 5.50001 19 3.04341 16 3.00001C14.5 2.9783 13 3.50003 12 5.00002C11 3.50003 9.47405 3.00001 8 3.00001C7.83316 3.00001 7.66632 3.00774 7.5 3.02294"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 2L4.3116 4.3116M21 21L17.5064 17.5064M17.5064 17.5064C15.093 19.7034 12.5092 21 12 21C11 21 2 16 2 8.99999C2 7.03227 2.94824 5.38062 4.3116 4.3116M17.5064 17.5064L4.3116 4.3116M19.7977 15C19.8662 14.9076 19.9337 14.8144 20 14.7203C21.1765 13.0519 22 11.1174 22 8.99999C22 5.50001 19 3.04341 16 3.00001C14.5 2.9783 13 3.50003 12 5.00002C11 3.50003 9.47405 3.00001 8 3.00001C7.83316 3.00001 7.66632 3.00774 7.5 3.02294"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M4.84193 3.7812C4.57368 3.51295 4.14736 3.48725 3.84883 3.72133C2.32383 4.91708 1.25 6.77787 1.25 8.99992C1.25 12.8217 3.69522 16.0099 6.12491 18.1839C7.35322 19.2829 8.61307 20.1553 9.63581 20.756C10.1469 21.0562 10.6068 21.2932 10.9812 21.4579C11.1677 21.54 11.3419 21.608 11.4962 21.6569C11.6316 21.6999 11.8167 21.7499 12 21.7499C12.186 21.7499 12.3746 21.6984 12.5126 21.6542C12.6701 21.6037 12.8484 21.5335 13.0398 21.4486C13.424 21.2783 13.8965 21.0331 14.4213 20.7223C15.4712 20.1007 16.7626 19.1976 18.0113 18.0609C18.1629 17.9229 18.2514 17.7289 18.2562 17.5239C18.261 17.319 18.1817 17.121 18.0367 16.976L4.84193 3.7812Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L4.84193 3.78127L18.0367 16.9761L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L16.9761 18.0367L3.78127 4.84193L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967ZM15.9891 3.74993C14.6789 3.73097 13.4503 4.17673 12.624 5.41605C12.4849 5.62469 12.2508 5.75002 12 5.75002C11.7492 5.75002 11.5151 5.62469 11.376 5.41605C10.5543 4.18355 9.30338 3.75001 8 3.75001C7.85633 3.75001 7.71228 3.75667 7.56828 3.76983C7.15579 3.80754 6.79083 3.50372 6.75311 3.09123C6.7154 2.67874 7.01922 2.31377 7.43172 2.27606C7.62037 2.25881 7.80999 2.25001 8 2.25001C9.37536 2.25001 10.86 2.64616 11.9984 3.80946C13.1283 2.64408 14.5981 2.22964 16.0109 2.25008C19.3659 2.29863 22.75 5.03724 22.75 8.99999C22.75 11.3172 21.8486 13.4002 20.6129 15.1525C20.5431 15.2516 20.4721 15.3497 20.4001 15.4467C20.1534 15.7795 19.6836 15.8492 19.3509 15.6024C19.0182 15.3557 18.9485 14.886 19.1952 14.5533C19.2603 14.4656 19.3242 14.3772 19.3871 14.2881C20.5044 12.7036 21.25 10.9177 21.25 8.99999C21.25 5.96278 18.6341 3.7882 15.9891 3.74993Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
